export const projectsPreview = [
  {
    title: "INDO EROPA Platform",
    shortTitle: "INDO EROPA",
    description:
      "A modern catalogue and checkout platform with automated workflows and seamless external integrations.",
    tags: ["Catalogues", "Checkout", "Notion integration"],
    preview: "/images/indoeropa/indoeropa-preview.png",
    alt: "INDO EROPA website preview",
    domain: "indoeropa.com",
    projectPath: "/projects/indoeropa",
    website: "https://indoeropa.com",
    glow: "bg-primary/[0.14]",
    badge: "border-accent/30 bg-accent text-gray-950",
    badgeText: "text-gray-700",
  },
  {
    title: "Twizel Website",
    shortTitle: "TWIZEL",
    description:
      "A playful, responsive drinks website designed around menu discovery, preorders, events, and direct customer contact.",
    tags: ["Responsive design", "Menu browsing", "WhatsApp ordering"],
    preview: "/images/twizel/twizel-preview.png",
    alt: "Twizel website preview",
    domain: "twizel.id",
    projectPath: "/projects/twizel",
    website: "https://www.twizel.id",
    glow: "bg-emerald-300/[0.12]",
    badge: "border-emerald-200/30 bg-emerald-100 text-emerald-950",
    badgeText: "text-emerald-800",
  },
];

export const projects = [
  {
    id: "indoeropa",
    category: "Custom Digital Platform",
    title: "INDO EROPA Platform",
    description:
      "A modern custom platform with responsive design, automated workflows, and external integrations for a seamless digital experience.",
    link: "https://indoeropa.com",
    image: "/images/indoeropa/indoeropa-mobile-preview.png",
    detailImage: "/images/indoeropa/indoeropa-shipping.png",
    features: [
      "Responsive product catalogue",
      "Integrated checkout functionality",
      "Automated Notion integration",
    ],
  },

  {
    id: "twizel",
    category: "Food & Beverage Website",
    title: "Twizel",
    description:
      "A playful and conversion-focused website created for an Indonesian beverage brand, presenting its menu, services, and ordering options clearly.",
    link: "https://www.twizel.id",
    image: "/images/twizel/twizel-mobile-preview.png",
    detailImage: "/images/twizel/twizel-menu-preview.png",
    features: [
      "Responsive menu presentation",
      "WhatsApp ordering integration",
      "Event and catering information",
    ],
  },
];
